import axios from 'axios';
export default{
    
    async getPurchase(context,payload){
        var pn=payload.page_no;
        var option=payload.option;
        await  axios.get(`admin/purchase.php?action=getPurchase&option_id=${option}&page_no=${pn}`)
        .then((res) => {

                var data= res.data.details;
                var pagination=res.data.pagination;
                var pagination_text = res.data.pagination_text;
                var active= res.data.active;
                context.commit('setPurchase',{data:data,pagination:pagination,pagination_text:pagination_text,active:active})
        })
        .catch((error) => {console.log(error); 
             error = new Error(error ||'Failed to authenticate.');
            throw error;      
        })
    },
    async getUserPurchase(context,payload){
        var pn=payload.page_no;
        var option=payload.option;
        var date=payload.date;
        var userid=localStorage.getItem("userId");
        
        await  axios.get(`admin/purchase.php?action=getUserPurchase&option_id=${option}&page_no=${pn}&date=${date}&userId=${userid}`)
        .then((res) => {

                var data= res.data.details;
                var pagination=res.data.pagination;
                var pagination_text = res.data.pagination_text;
                var active= res.data.active;
                context.commit('setPurchase',{data:data,pagination:pagination,pagination_text:pagination_text,active:active})
        })
        .catch((error) => {console.log(error); 
             error = new Error(error ||'Failed to authenticate.');
            throw error;      
        })
    },
    async getOption(context,payload){
        var id=payload.id;
        await  axios.get(`admin/purchase.php?action=getoption&id=${id}`)
        .then((res) => {
            if(!res.data.successmsg || res.data.error){
                const error = new Error(error ||'Something Wrong try again later.');
                throw error;
            }else{
                var itemdata= res.data.itemdata;
                var projectdata= res.data.projectdata;
                context.commit('setItemOption',{data:itemdata});
                context.commit('setProjectOption',{data:projectdata})
            }
        })
        .catch((error) => {console.log(error); 
             error = new Error(error ||'Failed to authenticate.');
            throw error;      
        })
    },
    async addPurchase(context,payload){
        var userid=localStorage.getItem("userId");
        var data = new FormData();
        data.append('purchase_date',payload.date);
        data.append('suppiler_name',payload.suppiler);
        data.append('project_id',payload.project);
        data.append('item_name',payload.itemName);
        data.append('item_id',payload.item_id);
        data.append('bill_amount',payload.bill_amount);
        data.append('userid',userid);
        data.append('purchase_detail',payload.purchase_detail);
        data.append('file',payload.file);
        await  axios.post(`admin/purchase.php?action=addpurchase`,data)
        .then((res) => {
            if(!res.data.successmsg || res.data.error){
                const error = new Error(error );
                throw error;
            }
            
        })
        .catch((error) => {console.log(error); 
             error = new Error(error ||'Failed to authenticate.');
            throw error;      
        })

        
    },
    async singleGetPurchase(context,payload){
        var id=payload.id
        await  axios.get(`admin/purchase.php?action=getsinglepurchase&id=${id}`)
        .then((res) => {
            if(!res.data.successmsg || res.data.error){
                const error = new Error(error ||'Something Wrong try again later.');
                throw error;
            }else{
                var data= res.data.details;
                context.commit('setSinglePurchase',{data:data})                
            }
        })
        .catch((error) => {console.log(error); 
             error = new Error(error ||'Failed to authenticate.');
            throw error;      
        })
    },
    async updatePurchase(context,payload){
        //var userid=localStorage.getItem("userId");
        var data = new FormData();
            data.append('id',payload.id); 
           data.append('purchase_date',payload.date);
           data.append('suppiler_name',payload.suppiler);
           data.append('project_id',payload.project);
           data.append('item_name',payload.itemName);
           data.append('item_id',payload.item_id);
           data.append('bill_amount',payload.bill_amount);
           data.append('userid',payload.userid);
            data.append('purchase_detail',payload.purchase_detail);
            data.append('file',payload.file);
            data.append('file_name',payload.file_name);
            
           await  axios.post(`admin/purchase.php?action=updatepurchase`,data)
           .then((res) => {
               if(!res.data.successmsg || res.data.error){
                   const error = new Error(error );
                   throw error;
               }
               //alert(res.data);
               
           })
           .catch((error) => {console.log(error); 
                error = new Error(error ||'Failed to authenticate.');
               throw error;      
           })
           
       },
       async additem(context,payload){
        var data = new FormData();
           data.append('item',payload.item);
           await  axios.post(`admin/purchase.php?action=additem`,data)
           .then((res) => {
               if(!res.data.successmsg || res.data.error){
                   const error = new Error(error ||'Something Wrong try again later.');
                   throw error;
               }
           })
           .catch((error) => {console.log(error); 
                error = new Error(error ||'Failed to authenticate.');
               throw error;      
           })
           
       },
       async DeletePurchase(context,payload){
        var id=payload.id
        await  axios.get(`admin/purchase.php?action=delPurchase&id=${id}`)
        .then((res) => {
            console.log(res);
            if(!res.data.successmsg || res.data.error){
                const error = new Error(error ||'Something Wrong try again later.');
                throw error;
            }else{
                    context.commit('delMessage',{data:'Deleted Successfully'})           
            }
        })
        .catch((error) => {console.log(error); 
             error = new Error(error ||'Failed to authenticate.');
            throw error;      
        })
    },
}